
import { CircularProgress, CssBaseline, Grid2 } from '@mui/material';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter';
// import i18n from '@src/i18nconf/i18nSetting';
import { Suspense } from 'react';
import Home from './home';

function Loading() {
  return (
    <Grid2
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{ minHeight: '100vh' }}>
      <CircularProgress color="secondary" />
    </Grid2>
  );
}

function Index() {
  return (
    <AppRouterCacheProvider>
      <CssBaseline />
      <Suspense fallback={<Loading />}>
        {/* <I18nextProvider i18n={i18n}> */}
          <Home/>
        {/* </I18nextProvider> */}
      </Suspense>
    </AppRouterCacheProvider>

  );
}
export default Index;
